export const visit = (vm, at) => {
vm(require("foundations-components/lang/ru.lyaml"));
at({ "ru": { "placeholder": "\u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C" } });
};